import {
	gsap
} from "gsap/dist/gsap";
import {
	ScrollTrigger
} from "gsap/dist/ScrollTrigger";
import {
	ScrollToPlugin
} from "gsap/dist/ScrollToPlugin";
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
const mainContent = document.getElementById('site');
const preLoaderEl = document.querySelector('.preloader');
const headerBar = mainContent.querySelector('#masthead');
const headerHero = document.querySelector('.entry-header .img-Hero');
var headerBarAnimate = gsap.timeline({
	paused: false, // default is false
	smoothChildTiming: true,
});
headerBarAnimate
	.fromTo(
	headerBar, {
		opacity: 0,
		}, {
			opacity: 1,
			duration: 0.5,
		},
	 "<.2")
	.fromTo(headerBar, {
		scale: 0.95
	}, {
		scale: 1,
		duration: 1
	}, "<.1");
document.addEventListener("DOMContentLoaded", function () {
	if (preLoaderEl) {
		setTimeout(function () {
			preLoaderEl.classList.add('hide');
			mainContent.classList.remove('overflow-hidden');
			mainContent.classList.remove('opacity-0');
			mainContent.classList.add('opacity-100');
			window.scroll({
				top: 0,
				left: 0,
				behavior: 'smooth'
			});
		}, 1300);
		setTimeout(function(){
			headerBarAnimate.play();
			let timelinePortfolioblog = gsap.timeline({
				paused: true, // default is false
				defaults: { // children inherit these defaults
					duration: 1,
					
					ease: "power2.out"
				},
				smoothChildTiming: true,
			});
			timelinePortfolioblog
			.fromTo(headerHero,{
				scale:1.2,
			},{
				scale:1,
				duration:1
			},'<.1')
			.fromTo('.header-title',{
				scale:1.1
			},{
				scale:1,
				duration:1
			},'<.1')
			.play();	
			const orelyPatterns = document.querySelectorAll('.orely-pattern');
			orelyPatterns.forEach(orelyPattern => {
			const childElements = orelyPattern.querySelectorAll('*');
			childElements.forEach(childElement => {	
				const animation = gsap.timeline({
				scrollTrigger: {
					trigger: childElement,
					start: "top 95%",
					end: "bottom center",
				},
				});
				if (!childElement.querySelector('img.btn-image')) {
					// Tambahkan animasi sesuai kebutuhan
					if (childElement.tagName.toLowerCase() === 'figure') {
						// Jika elemen adalah <figure>, berikan animasi pada elemen <img> dengan animasi scale
						const img = childElement.querySelector('img');
						if (img) {
							animation.fromTo(img, { scale: 1.2, opacity: 0 }, { scale: 1, opacity: 1, duration: 0.8 }, "<.2");
						}
					} else {
						// Jika elemen bukan <figure>, berikan animasi fade in up
						animation.fromTo(childElement, { opacity: 0, y: '40px' }, { y: '0px', opacity: 1, duration: 0.8 }, "<.2");
					}
				}
			});
		});		
	}, 1300);
		const portofolio = document.querySelectorAll('.our-work__portofolio');
    portofolio.forEach((portofolioItem, index) => {
      const cardAnimate = gsap.timeline({
        paused: true, 
        defaults: {
          duration: 0.8,
          ease: "power2.out"
        },
      });
      cardAnimate
      .fromTo(portofolioItem.children[0], {
        width: '75%',
        duration: 1,
    }, {
        width: '100%',
        stagger: .2
    }, '<.1')
    .fromTo(portofolioItem.children[0].children[0], {
        scale: 1.2
    }, {
        duration: 1,
        scale: 1,
        stagger: .2
    }, '-=1');
      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            cardAnimate.play(); 
            observer.unobserve(entry.target); 
          }
        });
      });
      observer.observe(portofolioItem);
    });
	}
});